module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ql-sub-header"
  }, [_c('md-list', {
    staticClass: "note-tools-list-left",
    class: _vm.selectedThumbnailView === 'true' ? 'thumb-note-tool-list' : ''
  }, [(_vm.selectedThumbnailView === 'true') ? _c('md-list-item', {
    staticClass: "multi-tools multi-icon-tools"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.selectThumbnailView('false')
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "role": "img",
      "aria-label": "Script View"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.5,0H2.5A2.5,2.5,0,0,0,0,2.5v13A2.5,2.5,0,0,0,2.5,18h13A2.5,2.5,0,0,0,18,15.5V2.5A2.5,2.5,0,0,0,15.5,0Zm1.09,15.74-.84.84H2.25l-.84-.84V2.26l.84-.84h13.5l.84.84Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12,12.5H6a1,1,0,0,1-1-1V10.18a.75.75,0,0,1,.22-.53L7.35,7.51a.75.75,0,0,1,1.06,0h0l2.11,2.1L11.13,9a.76.76,0,0,1,1,0l.6.61a.75.75,0,0,1,.22.53V11.5A1,1,0,0,1,12,12.5Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12.6,5.5H11.4l-.4.4V7.1l.4.4h1.2l.4-.4V5.9Z"
    }
  })])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Script View")])], 1)], 1) : (_vm.selectedThumbnailView === 'false') ? _c('md-list-item', {
    staticClass: "multi-tools multi-icon-tools"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.selectThumbnailView('true')
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "role": "img",
      "aria-label": "Thumbnail View"
    }
  }, [_c('g', {
    attrs: {
      "id": "_03_dashboard_layout_grid",
      "data-name": " 03 dashboard layout grid"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.66,0H2.3A2.3,2.3,0,0,0,0,2.3V5.66A2.31,2.31,0,0,0,2.3,8H5.66A2.31,2.31,0,0,0,8,5.66V2.3A2.31,2.31,0,0,0,5.66,0Zm1,5.66a1,1,0,0,1-1,1H2.3a1,1,0,0,1-1-1V2.3a1,1,0,0,1,1-1H5.66a1,1,0,0,1,1,1ZM15.7,0H12.34A2.31,2.31,0,0,0,10,2.3V5.66A2.31,2.31,0,0,0,12.34,8H15.7A2.31,2.31,0,0,0,18,5.66V2.3A2.3,2.3,0,0,0,15.7,0Zm1,5.66a1,1,0,0,1-1,1H12.34a1,1,0,0,1-1-1V2.3a1,1,0,0,1,1-1H15.7a1,1,0,0,1,1,1ZM5.66,10H2.3A2.31,2.31,0,0,0,0,12.34V15.7A2.3,2.3,0,0,0,2.3,18H5.66A2.31,2.31,0,0,0,8,15.7V12.34A2.31,2.31,0,0,0,5.66,10Zm1,5.66a1,1,0,0,1-1,1H2.3a1,1,0,0,1-1-1V12.34a1,1,0,0,1,1-1H5.66a1,1,0,0,1,1,1Zm9-5.66H12.34a2.31,2.31,0,0,0-2.3,2.3V15.7a2.31,2.31,0,0,0,2.3,2.3H15.7A2.3,2.3,0,0,0,18,15.7V12.34A2.31,2.31,0,0,0,15.7,10Zm1,5.66a1,1,0,0,1-1,1H12.34a1,1,0,0,1-1-1V12.34a1,1,0,0,1,1-1H15.7a1,1,0,0,1,1,1Z"
    }
  })])])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Thumbnail View")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedThumbnailView === 'false') ? _c('md-list-item', {
    staticClass: "multi-tools multi-icon-tools"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.toggleBookmarkNav()
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.59,0H6.36A1.83,1.83,0,0,0,4.53,1.81v.35a3.23,3.23,0,0,0-1.24.3A3,3,0,0,0,1.94,3.81,6.33,6.33,0,0,0,1.6,6.67V17.35a.66.66,0,0,0,.47.63.71.71,0,0,0,.5-.06L7,15.37l.89-.51.89.51,4.46,2.55a.61.61,0,0,0,.32.08.65.65,0,0,0,.65-.65v-2h.35a1.82,1.82,0,0,0,1.81-1.83V1.81A1.81,1.81,0,0,0,14.59,0ZM13,16.24l-1.54-.87-2-1.16-1.14-.65a.66.66,0,0,0-.64,0l-1.14.65-1.27.73-2.3,1.3V6.67a5.88,5.88,0,0,1,.2-2.28,1.74,1.74,0,0,1,.77-.77,2.1,2.1,0,0,1,.67-.17c.29,0,.67,0,1.16,0h4a5.7,5.7,0,0,1,2.24.2,1.66,1.66,0,0,1,.78.77A5.88,5.88,0,0,1,13,6.67v9.57Zm2.29-2.7a.65.65,0,0,1-.65.67h-.35V6.67a6.33,6.33,0,0,0-.34-2.86,3,3,0,0,0-1.35-1.35A6.46,6.46,0,0,0,9.7,2.13h-4V1.81a.67.67,0,0,1,.67-.65h8.23a.65.65,0,0,1,.65.65Z"
    }
  })])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v(_vm._s(_vm.bookmarkNavOpened ? 'Close navigation' : 'Open navigation (Structure / My Bookmarks)'))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectedThumbnailView === 'false' && !_vm.isLocked) ? _c('md-list-item', {
    staticClass: "multi-tools has-sub-menu layer-options"
  }, [_c('md-button', {
    staticClass: "md-icon-button additional-options",
    on: {
      "click": function($event) {
        return _vm.openMenuTool('cueLayer')
      }
    }
  }, [(_vm.currentCueLayer && _vm.currentCueLayer.title) ? _c('span', [_vm._v("Active Cue Layer: "), _c('strong', {
    style: (_vm.cueLayerStyle)
  }, [_vm._v(_vm._s(_vm.currentCueLayer && _vm.currentCueLayer.title && _vm.currentCueLayer.title))])]) : _c('span', [_vm._v("Select Layer")]), _vm._v(" "), (_vm.currentCueLayer && _vm.currentCueLayer.title) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Change Active Cue Layer")]) : _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Select Layer")])], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container",
    on: {
      "click": function($event) {
        return _vm.preventContext($event, 'cueLayer')
      }
    }
  }, [_c('span', {
    staticClass: "move-button"
  }, [_c('div', {
    staticClass: "fill-button"
  }), _vm._v(" "), _c('md-tooltip', [_vm._v("Change Stamp")])], 1)]), _vm._v(" "), (_vm.isToolCueLayerMenu && _vm.validCueLayers.length > 0) ? _c('div', {
    staticClass: "ql-menu-wrapper"
  }, [_c('md-list', {
    staticClass: "ql-menu-container"
  }, _vm._l((_vm.validCueLayers), function(layer, i) {
    return _c('md-list-item', {
      key: layer.id,
      staticClass: "md-icon-button",
      class: {
        'selected': _vm.currentCueLayer && _vm.currentCueLayer.id === layer.id
      },
      on: {
        "click": function($event) {
          return _vm.selectTool('cueLayer', i)
        }
      }
    }, [_c('span', {
      style: ({
        color: layer.color
      })
    }, [_vm._v(_vm._s(layer.title))])])
  }), 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.selectedThumbnailView === 'false' && !_vm.isLocked) ? _c('md-list-item', {
    staticClass: "multi-tools has-sub-menu layer-options"
  }, [_c('md-button', {
    staticClass: "md-icon-button additional-options",
    on: {
      "click": function($event) {
        return _vm.openMenuTool('noteLayer')
      }
    }
  }, [(_vm.currentNoteLayer && _vm.currentNoteLayer.title) ? _c('span', [_vm._v("Active Note Layer: "), _c('strong', {
    style: (_vm.noteLayerStyle)
  }, [_vm._v(_vm._s(_vm.currentNoteLayer && _vm.currentNoteLayer.title && _vm.currentNoteLayer.title))])]) : _c('span', [_vm._v("Select Layer")]), _vm._v(" "), (_vm.currentNoteLayer && _vm.currentNoteLayer.title) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Change Active Note Layer")]) : _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Select Layer")])], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container",
    on: {
      "click": function($event) {
        return _vm.preventContext($event, 'noteLayer')
      }
    }
  }, [_c('span', {
    staticClass: "move-button"
  }, [_c('div', {
    staticClass: "fill-button"
  }), _vm._v(" "), _c('md-tooltip', [_vm._v("Change Note Layer")])], 1)]), _vm._v(" "), (_vm.isToolNoteLayerMenu && _vm.validNoteLayers.length > 0) ? _c('div', {
    staticClass: "ql-menu-wrapper"
  }, [_c('md-list', {
    staticClass: "ql-menu-container"
  }, _vm._l((_vm.validNoteLayers), function(layer, i) {
    return _c('md-list-item', {
      key: layer.id,
      staticClass: "md-icon-button",
      class: {
        'selected': _vm.currentNoteLayer && _vm.currentNoteLayer.id === layer.id
      },
      on: {
        "click": function($event) {
          return _vm.selectTool('noteLayer', i)
        }
      }
    }, [_c('span', {
      style: ({
        color: layer.color
      })
    }, [_vm._v(_vm._s(layer.title))])])
  }), 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.selectedThumbnailView === 'false') ? _c('md-list-item', {
    staticClass: "multi-tools has-sub-menu layer-options ql-page-follow"
  }, [_c('md-button', {
    staticClass: "md-icon-button additional-options",
    on: {
      "click": function($event) {
        return _vm.openMenuTool('pageFollow')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "ql-pf-dot",
    class: 'ql-pf-dot--' + _vm.pfState
  }), _vm._v("Mirror: "), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.pfLabel)
    }
  })]), _vm._v(" "), (_vm.pfFollowerCount > 0) ? _c('span', {
    staticClass: "ql-pf-followers"
  }, [_vm._v("· " + _vm._s(_vm.pfFollowerCount) + " following")]) : _vm._e(), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Mirror another person's page. Turning a page yourself switches this off.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container",
    on: {
      "click": function($event) {
        return _vm.preventContext($event, 'pageFollow')
      }
    }
  }, [_c('span', {
    staticClass: "move-button"
  }, [_c('div', {
    staticClass: "fill-button"
  }), _vm._v(" "), _c('md-tooltip', [_vm._v("Change Mirror")])], 1)]), _vm._v(" "), (_vm.isToolPageFollowMenu) ? _c('div', {
    staticClass: "ql-menu-wrapper"
  }, [_c('md-list', {
    staticClass: "ql-menu-container"
  }, [_c('md-list-item', {
    staticClass: "md-icon-button",
    class: {
      'selected': !_vm.pfFollowUid
    },
    on: {
      "click": function($event) {
        return _vm.pickFollow(null)
      }
    }
  }, [_c('span', [_vm._v("Off")])]), _vm._v(" "), _vm._l((_vm.followablePeers), function(peer) {
    return _c('md-list-item', {
      key: peer.uid,
      staticClass: "md-icon-button",
      class: {
        'selected': peer.uid === _vm.pfFollowUid,
        'ql-pf-unavailable': peer.followsMe
      },
      on: {
        "click": function($event) {
          return _vm.pickFollow(peer.followsMe ? _vm.pfFollowUid : peer.uid)
        }
      }
    }, [_c('span', {
      staticClass: "ql-pf-peer-name",
      domProps: {
        "textContent": _vm._s(peer.name)
      }
    }), _vm._v(" "), (peer.followsMe) ? _c('span', {
      staticClass: "ql-pf-peer-page"
    }, [_vm._v("following you")]) : _c('span', {
      staticClass: "ql-pf-peer-page"
    }, [_vm._v("p. " + _vm._s(peer.pageLabel))])])
  }), _vm._v(" "), (_vm.followablePeers.length === 0) ? _c('md-list-item', {
    staticClass: "md-icon-button ql-pf-empty"
  }, [_c('span', [_vm._v("No one else is in this project")])]) : _vm._e()], 2)], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.selectedThumbnailView === 'false') ? _c('div', {
    staticClass: "ql-zoom-wrapper"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    class: {
      disabled: this.zoomDisabledOut
    },
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.375 9.25C13.5408 9.25 13.6997 9.18415 13.8169 9.06694C13.9342 8.94973 14 8.79076 14 8.625C14 8.45924 13.9342 8.30027 13.8169 8.18306C13.6997 8.06585 13.5408 8 13.375 8H2.625C2.45924 8 2.30027 8.06585 2.18306 8.18306C2.06585 8.30027 2 8.45924 2 8.625C2 8.79076 2.06585 8.94973 2.18306 9.06694C2.30027 9.18415 2.45924 9.25 2.625 9.25H13.375Z",
      "fill": "black"
    }
  })])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Zoom Out (-)")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    class: {
      disabled: this.zoomDisabledIn
    },
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.00488 9.75V14C7.00488 14.1658 7.07073 14.3247 7.18794 14.4419C7.30515 14.5592 7.46412 14.625 7.62988 14.625C7.79564 14.625 7.95461 14.5592 8.07183 14.4419C8.18904 14.3247 8.25488 14.1658 8.25488 14V9.75L8.75488 9.25H13.0049C13.1706 9.25 13.3296 9.18415 13.4468 9.06694C13.564 8.94973 13.6299 8.79076 13.6299 8.625C13.6299 8.45924 13.564 8.30027 13.4468 8.18306C13.3296 8.06585 13.1706 8 13.0049 8H8.75488L8.25488 7.5V3.25C8.25488 3.08424 8.18904 2.92527 8.07183 2.80806C7.95461 2.69085 7.79564 2.625 7.62988 2.625C7.46412 2.625 7.30515 2.69085 7.18794 2.80806C7.07073 2.92527 7.00488 3.08424 7.00488 3.25V7.5L6.50488 8H2.25488C2.08912 8 1.93015 8.06585 1.81294 8.18306C1.69573 8.30027 1.62988 8.45924 1.62988 8.625C1.62988 8.79076 1.69573 8.94973 1.81294 9.06694C1.93015 9.18415 2.08912 9.25 2.25488 9.25H6.39188L7.00488 9.75Z",
      "fill": "black"
    }
  })])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Zoom In (+)")])], 1), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.selectedScale
    },
    on: {
      "change": _vm.changeZoom
    }
  }, [_c('option', {
    attrs: {
      "value": "0.5"
    }
  }, [_vm._v("50%")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0.75"
    }
  }, [_vm._v("75%")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("100%")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1.25"
    }
  }, [_vm._v("125%")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1.5"
    }
  }, [_vm._v("150%")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("200%")]), _vm._v(" "), (!_vm.isIpad) ? _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("300%")]) : _vm._e(), _vm._v(" "), (!_vm.isIpad) ? _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("400%")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "hidden": "true"
    },
    domProps: {
      "value": _vm.selectedScale
    }
  }, [_vm._v(_vm._s(Number.parseInt(_vm.selectedScale * 100, 10)) + "%")])])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedThumbnailView === 'true') ? _c('div', {
    staticClass: "ql-zoom-wrapper ql-list-widget dss"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [(!_vm.isAdministrator || _vm.versionID) ? _c('md-button', {
    staticClass: "md-icon-button ql-text-btn",
    attrs: {
      "disabled": true
    }
  }, [_c('span', [_vm._v("Replace")]), _vm._v(" "), _c('md-icon', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "32",
      "viewBox": "0 0 24 24",
      "role": "img",
      "aria-label": "Replace"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "m14 3l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7v2l4-3l-4-3v2H4V3zm7 7v11a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-2h2v2h11v-9h-5V7H8v6H6V7a2 2 0 0 1 2-2h8z"
    }
  })])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Replace")])], 1) : _c('md-button', {
    staticClass: "md-icon-button ql-text-btn",
    attrs: {
      "disabled": _vm.selectedPageRenameIndices.length === 0 || _vm.isLocked
    },
    on: {
      "click": function($event) {
        return _vm.openReplacePage()
      }
    }
  }, [_c('span', [_vm._v("Replace")]), _vm._v(" "), _c('md-icon', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "32",
      "viewBox": "0 0 24 24",
      "role": "img",
      "aria-label": "Replace"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "m14 3l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7v2l4-3l-4-3v2H4V3zm7 7v11a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-2h2v2h11v-9h-5V7H8v6H6V7a2 2 0 0 1 2-2h8z"
    }
  })])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Replace")])], 1), _vm._v(" "), (!_vm.isAdministrator || _vm.versionID) ? _c('md-button', {
    staticClass: "md-icon-button ql-text-btn",
    attrs: {
      "disabled": true
    }
  }, [_c('span', [_vm._v("Insert")]), _vm._v(" "), _c('md-icon', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 106.19 121.03",
      "role": "img",
      "aria-label": "Insert"
    }
  }, [_c('g', {
    attrs: {
      "data-name": "Layer 2"
    }
  }, [_c('g', {
    attrs: {
      "data-name": "Layer 1"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.93,11.93H53.7V41.76H83.53V54H95.46V35.8L59.66,0H11.93A11.92,11.92,0,0,0,.06,11.93L0,107.39a11.92,11.92,0,0,0,11.88,11.93H47.7V107.39H11.93Zm48.7,1.22L82.41,34.93H60.63Z"
    }
  }), _c('polygon', {
    attrs: {
      "points": "84.4 87.4 84.4 64.75 73.23 64.75 73.23 87.4 51.45 87.4 51.45 98.19 73.23 98.19 73.23 121.03 84.4 121.03 84.4 98.19 106.19 98.19 106.19 87.4 84.4 87.4"
    }
  })])])])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Insert")])], 1) : _c('md-button', {
    staticClass: "md-icon-button ql-text-btn",
    attrs: {
      "disabled": _vm.selectedPageRenameIndices.length === 0 || _vm.isLocked
    },
    on: {
      "click": function($event) {
        return _vm.openCreatePage()
      }
    }
  }, [_c('span', [_vm._v("Insert")]), _vm._v(" "), _c('md-icon', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 106.19 121.03",
      "role": "img",
      "aria-label": "Insert"
    }
  }, [_c('g', {
    attrs: {
      "data-name": "Layer 2"
    }
  }, [_c('g', {
    attrs: {
      "data-name": "Layer 1"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.93,11.93H53.7V41.76H83.53V54H95.46V35.8L59.66,0H11.93A11.92,11.92,0,0,0,.06,11.93L0,107.39a11.92,11.92,0,0,0,11.88,11.93H47.7V107.39H11.93Zm48.7,1.22L82.41,34.93H60.63Z"
    }
  }), _c('polygon', {
    attrs: {
      "points": "84.4 87.4 84.4 64.75 73.23 64.75 73.23 87.4 51.45 87.4 51.45 98.19 73.23 98.19 73.23 121.03 84.4 121.03 84.4 98.19 106.19 98.19 106.19 87.4 84.4 87.4"
    }
  })])])])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Insert")])], 1), _vm._v(" "), (!_vm.isAdministrator || _vm.versionID) ? _c('md-button', {
    staticClass: "md-icon-button ql-text-btn",
    attrs: {
      "disabled": true
    }
  }, [_c('span', [_vm._v("Delete")]), _vm._v(" "), _c('md-icon', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 94 94",
      "role": "img",
      "aria-label": "Delete"
    }
  }, [_c('g', {
    attrs: {
      "data-name": "Layer 2"
    }
  }, [_c('g', {
    attrs: {
      "data-name": "Layer 1"
    }
  }, [_c('path', {
    attrs: {
      "d": "M89,16.8H75.37l-4.3-9.11A13.45,13.45,0,0,0,59,0H35.05A13.45,13.45,0,0,0,22.93,7.69l-4.3,9.11H5a5,5,0,0,0,0,10H8.93l6.14,55.28A13.38,13.38,0,0,0,28.38,94H65.62A13.38,13.38,0,0,0,78.93,82.08L85.08,26.8H89a5,5,0,0,0,0-10ZM32,12A3.43,3.43,0,0,1,35.05,10H59A3.43,3.43,0,0,1,62,12l2.29,4.85H29.68ZM69,81a3.39,3.39,0,0,1-3.37,3H28.38A3.39,3.39,0,0,1,25,81L19,26.8H75Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M38.6,37.8a5,5,0,0,0-5,5v21a5,5,0,0,0,10,0v-21A5,5,0,0,0,38.6,37.8Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M55.4,37.8a5,5,0,0,0-5,5v21a5,5,0,0,0,10,0v-21A5,5,0,0,0,55.4,37.8Z"
    }
  })])])])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Delete")])], 1) : _c('md-button', {
    staticClass: "md-icon-button ql-text-btn",
    attrs: {
      "disabled": _vm.selectedPageRenameIndices.length === 0 || _vm.isLocked
    },
    on: {
      "click": function($event) {
        return _vm.openDeletePage()
      }
    }
  }, [_c('span', [_vm._v("Delete")]), _vm._v(" "), _c('md-icon', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 94 94",
      "role": "img",
      "aria-label": "Delete"
    }
  }, [_c('g', {
    attrs: {
      "data-name": "Layer 2"
    }
  }, [_c('g', {
    attrs: {
      "data-name": "Layer 1"
    }
  }, [_c('path', {
    attrs: {
      "d": "M89,16.8H75.37l-4.3-9.11A13.45,13.45,0,0,0,59,0H35.05A13.45,13.45,0,0,0,22.93,7.69l-4.3,9.11H5a5,5,0,0,0,0,10H8.93l6.14,55.28A13.38,13.38,0,0,0,28.38,94H65.62A13.38,13.38,0,0,0,78.93,82.08L85.08,26.8H89a5,5,0,0,0,0-10ZM32,12A3.43,3.43,0,0,1,35.05,10H59A3.43,3.43,0,0,1,62,12l2.29,4.85H29.68ZM69,81a3.39,3.39,0,0,1-3.37,3H28.38A3.39,3.39,0,0,1,25,81L19,26.8H75Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M38.6,37.8a5,5,0,0,0-5,5v21a5,5,0,0,0,10,0v-21A5,5,0,0,0,38.6,37.8Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M55.4,37.8a5,5,0,0,0-5,5v21a5,5,0,0,0,10,0v-21A5,5,0,0,0,55.4,37.8Z"
    }
  })])])])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Delete")])], 1), _vm._v(" "), (!_vm.isAdministrator || _vm.versionID || _vm.selectedPageRenameIndices.length === 0) ? _c('md-button', {
    staticClass: "md-icon-button ql-text-btn",
    attrs: {
      "disabled": true
    }
  }, [_c('span', [_vm._v("Adjust Selected Page Numbers")]), _vm._v(" "), _c('md-icon', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "32",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16c1.671 0 3-1.331 3-3s-1.329-3-3-3s-3 1.331-3 3s1.329 3 3 3"
    }
  }), _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M20.817 11.186a8.94 8.94 0 0 0-1.355-3.219a9.053 9.053 0 0 0-2.43-2.43a8.95 8.95 0 0 0-3.219-1.355a9.028 9.028 0 0 0-1.838-.18V2L8 5l3.975 3V6.002c.484-.002.968.044 1.435.14a6.961 6.961 0 0 1 2.502 1.053a7.005 7.005 0 0 1 1.892 1.892A6.967 6.967 0 0 1 19 13a7.032 7.032 0 0 1-.55 2.725a7.11 7.11 0 0 1-.644 1.188a7.2 7.2 0 0 1-.858 1.039a7.028 7.028 0 0 1-3.536 1.907a7.13 7.13 0 0 1-2.822 0a6.961 6.961 0 0 1-2.503-1.054a7.002 7.002 0 0 1-1.89-1.89A6.996 6.996 0 0 1 5 13H3a9.02 9.02 0 0 0 1.539 5.034a9.096 9.096 0 0 0 2.428 2.428A8.95 8.95 0 0 0 12 22a9.09 9.09 0 0 0 1.814-.183a9.014 9.014 0 0 0 3.218-1.355a8.886 8.886 0 0 0 1.331-1.099a9.228 9.228 0 0 0 1.1-1.332A8.952 8.952 0 0 0 21 13a9.09 9.09 0 0 0-.183-1.814"
    }
  })])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Adjust Selected Page Numbers")])], 1) : _c('md-button', {
    staticClass: "md-icon-button ql-text-btn",
    attrs: {
      "disabled": _vm.selectedPageRenameIndices.length === 0 || _vm.isLocked
    },
    on: {
      "click": function($event) {
        return _vm.openAdjustSelectedResetPage()
      }
    }
  }, [_c('span', [_vm._v("Adjust Selected Page Numbers")]), _vm._v(" "), _c('md-icon', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "32",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16c1.671 0 3-1.331 3-3s-1.329-3-3-3s-3 1.331-3 3s1.329 3 3 3"
    }
  }), _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M20.817 11.186a8.94 8.94 0 0 0-1.355-3.219a9.053 9.053 0 0 0-2.43-2.43a8.95 8.95 0 0 0-3.219-1.355a9.028 9.028 0 0 0-1.838-.18V2L8 5l3.975 3V6.002c.484-.002.968.044 1.435.14a6.961 6.961 0 0 1 2.502 1.053a7.005 7.005 0 0 1 1.892 1.892A6.967 6.967 0 0 1 19 13a7.032 7.032 0 0 1-.55 2.725a7.11 7.11 0 0 1-.644 1.188a7.2 7.2 0 0 1-.858 1.039a7.028 7.028 0 0 1-3.536 1.907a7.13 7.13 0 0 1-2.822 0a6.961 6.961 0 0 1-2.503-1.054a7.002 7.002 0 0 1-1.89-1.89A6.996 6.996 0 0 1 5 13H3a9.02 9.02 0 0 0 1.539 5.034a9.096 9.096 0 0 0 2.428 2.428A8.95 8.95 0 0 0 12 22a9.09 9.09 0 0 0 1.814-.183a9.014 9.014 0 0 0 3.218-1.355a8.886 8.886 0 0 0 1.331-1.099a9.228 9.228 0 0 0 1.1-1.332A8.952 8.952 0 0 0 21 13a9.09 9.09 0 0 0-.183-1.814"
    }
  })])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Adjust Selected Page Numbers")])], 1)], 1), _vm._v(" "), (!_vm.isAdministrator || _vm.selectedPageRenameIndices.length > 0 || _vm.resetPopupModel || _vm.versionID) ? _c('md-button', {
    staticClass: "md-icon-button ql-text-btn btn-reset",
    attrs: {
      "disabled": true
    }
  }, [_c('span', [_vm._v("Reset All Page Numbering")]), _vm._v(" "), _c('md-icon', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "32",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16c1.671 0 3-1.331 3-3s-1.329-3-3-3s-3 1.331-3 3s1.329 3 3 3"
    }
  }), _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M20.817 11.186a8.94 8.94 0 0 0-1.355-3.219a9.053 9.053 0 0 0-2.43-2.43a8.95 8.95 0 0 0-3.219-1.355a9.028 9.028 0 0 0-1.838-.18V2L8 5l3.975 3V6.002c.484-.002.968.044 1.435.14a6.961 6.961 0 0 1 2.502 1.053a7.005 7.005 0 0 1 1.892 1.892A6.967 6.967 0 0 1 19 13a7.032 7.032 0 0 1-.55 2.725a7.11 7.11 0 0 1-.644 1.188a7.2 7.2 0 0 1-.858 1.039a7.028 7.028 0 0 1-3.536 1.907a7.13 7.13 0 0 1-2.822 0a6.961 6.961 0 0 1-2.503-1.054a7.002 7.002 0 0 1-1.89-1.89A6.996 6.996 0 0 1 5 13H3a9.02 9.02 0 0 0 1.539 5.034a9.096 9.096 0 0 0 2.428 2.428A8.95 8.95 0 0 0 12 22a9.09 9.09 0 0 0 1.814-.183a9.014 9.014 0 0 0 3.218-1.355a8.886 8.886 0 0 0 1.331-1.099a9.228 9.228 0 0 0 1.1-1.332A8.952 8.952 0 0 0 21 13a9.09 9.09 0 0 0-.183-1.814"
    }
  })])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Reset All Page Numbering")])], 1) : _c('md-button', {
    staticClass: "md-icon-button ql-text-btn btn-reset",
    attrs: {
      "disabled": _vm.isLocked
    },
    on: {
      "click": function($event) {
        return _vm.openResetPage()
      }
    }
  }, [_c('span', [_vm._v("Reset All Page Numbering")]), _vm._v(" "), _c('md-icon', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "32",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16c1.671 0 3-1.331 3-3s-1.329-3-3-3s-3 1.331-3 3s1.329 3 3 3"
    }
  }), _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M20.817 11.186a8.94 8.94 0 0 0-1.355-3.219a9.053 9.053 0 0 0-2.43-2.43a8.95 8.95 0 0 0-3.219-1.355a9.028 9.028 0 0 0-1.838-.18V2L8 5l3.975 3V6.002c.484-.002.968.044 1.435.14a6.961 6.961 0 0 1 2.502 1.053a7.005 7.005 0 0 1 1.892 1.892A6.967 6.967 0 0 1 19 13a7.032 7.032 0 0 1-.55 2.725a7.11 7.11 0 0 1-.644 1.188a7.2 7.2 0 0 1-.858 1.039a7.028 7.028 0 0 1-3.536 1.907a7.13 7.13 0 0 1-2.822 0a6.961 6.961 0 0 1-2.503-1.054a7.002 7.002 0 0 1-1.89-1.89A6.996 6.996 0 0 1 5 13H3a9.02 9.02 0 0 0 1.539 5.034a9.096 9.096 0 0 0 2.428 2.428A8.95 8.95 0 0 0 12 22a9.09 9.09 0 0 0 1.814-.183a9.014 9.014 0 0 0 3.218-1.355a8.886 8.886 0 0 0 1.331-1.099a9.228 9.228 0 0 0 1.1-1.332A8.952 8.952 0 0 0 21 13a9.09 9.09 0 0 0-.183-1.814"
    }
  })])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Reset All Page Numbering")]), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "resetPagesDialog",
    attrs: {
      "md-title": "Reset Numbering",
      "md-content-html": "Are you sure you want to restore sequential numbering to all pages? This can not be undone.",
      "md-ok-text": "Yes",
      "md-cancel-text": "Cancel"
    },
    on: {
      "close": _vm.confirmResetPages
    }
  })], 1), _vm._v(" "), _c('reset-page', {
    ref: "resetPage",
    attrs: {
      "toolbarManuType": _vm.toolbarManuType,
      "currentPage": _vm.currentPage,
      "reset_page_from": _vm.selectedPageRenameIndices[0],
      "reset_page_to": _vm.selectedPageRenameIndices[_vm.selectedPageRenameIndices.length - 1]
    },
    on: {
      "dialog-state-change": _vm.handleDialogStateChange,
      "thumbnailSelectionClick": _vm.thumbnailSelectionClick
    }
  }), _vm._v(" "), _c('insert-page', {
    ref: "insertPage",
    attrs: {
      "currentPage": _vm.currentPage,
      "add_page_into": _vm.selectedPageRenameIndices[_vm.selectedPageRenameIndices.length - 1]
    },
    on: {
      "thumbnailSelectionClick": _vm.thumbnailSelectionClick
    }
  }), _vm._v(" "), _c('delete-page', {
    ref: "deletePage",
    attrs: {
      "currentPage": _vm.currentPage,
      "delete_page_from": _vm.selectedPageRenameIndices[0],
      "delete_page_to": _vm.selectedPageRenameIndices[_vm.selectedPageRenameIndices.length - 1]
    },
    on: {
      "thumbnailSelectionClick": _vm.thumbnailSelectionClick
    }
  }), _vm._v(" "), _c('replace-page', {
    ref: "replacePage",
    attrs: {
      "currentPage": _vm.currentPage,
      "replace_page_from": _vm.selectedPageRenameIndices[0],
      "replace_page_to": _vm.selectedPageRenameIndices[_vm.selectedPageRenameIndices.length - 1]
    },
    on: {
      "thumbnailSelectionClick": _vm.thumbnailSelectionClick
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedThumbnailView === 'false') ? _c('div', {
    staticClass: "tools-palette"
  }, [_c('md-list', {
    staticClass: "note-tools-list"
  }, [(_vm.isIpad) ? _c('md-list-item', {
    class: {
      'selected': _vm.selectedTool === 'pointerSelect'
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.selectType($event, 'pointerSelect')
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "height": "24px",
      "viewBox": "0 -960 960 960",
      "width": "24px",
      "fill": "#5f6368"
    }
  }, [_c('path', {
    attrs: {
      "d": "M593-80q-24 0-46-9t-39-26L304-320l33-34q14-14 34-19t40 0l69 20v-287q0-17 11.5-28.5T520-680q17 0 28.5 11.5T560-640v393l-98-28 103 103q6 6 13 9t15 3h167q33 0 56.5-23.5T840-240v-160q0-17 11.5-28.5T880-440q17 0 28.5 11.5T920-400v160q0 66-47 113T760-80H593Zm7-280v-320q0-17 11.5-28.5T640-720q17 0 28.5 11.5T680-680v320h-80Zm120 0v-120q0-17 11.5-28.5T760-520q17 0 28.5 11.5T800-480v120h-80Zm40 200H565h195Zm-600-40q-33 0-56.5-23.5T80-280v-480q0-33 23.5-56.5T160-840h600q33 0 56.5 23.5T840-760v160h-80v-160H160v480h72l79 80H160Z"
    }
  })])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Pointer (P)")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-list-item', {
    class: {
      'selected': _vm.selectedTool === 'cueSelect'
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button ql-toolbar-letter-btn",
    on: {
      "click": function($event) {
        return _vm.selectType($event, 'cueSelect')
      }
    }
  }, [_c('span', {
    staticClass: "ql-toolbar-letter-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("C")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Cue (C)")])], 1)], 1), _vm._v(" "), _c('md-list-item', {
    class: {
      'selected': _vm.selectedTool === 'text'
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button ql-toolbar-letter-btn",
    on: {
      "click": function($event) {
        return _vm.selectType($event, 'text')
      }
    }
  }, [_c('span', {
    staticClass: "ql-toolbar-letter-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("T")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Text (T)")])], 1)], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "has-sub-menu",
    class: {
      'selected': _vm.selectedTool === 'free_drawing' || _vm.selectedTool === 'line'
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button additional-options",
    on: {
      "click": function($event) {
        return _vm.openMenuTool(_vm.selectedDrawTool)
      }
    }
  }, [_c('md-icon', [(_vm.selectedDrawTool === 'free_drawing') ? _c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.18,2,14,.72A2.06,2.06,0,0,0,11,.72L2.91,8.84l-1.32,4A1.16,1.16,0,0,0,1.87,14a1.21,1.21,0,0,0,1.22.29l4-1.32,8.13-8.14A2.06,2.06,0,0,0,15.18,2ZM12.06,6.28,6.37,12,2.74,13.16,4,9.47,9.71,3.76,12.15,6.2ZM14.33,4,13,5.34l-.09-.08L10.56,2.9l1.33-1.33a.89.89,0,0,1,1.2,0l1.24,1.24a.84.84,0,0,1,0,1.2Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M17.32,16.61l-2,.6a6.68,6.68,0,0,1-3.14.17l-2.42-.49a5.2,5.2,0,0,0-3.36.44,5,5,0,0,1-5.75-.86l.8-.9a3.85,3.85,0,0,0,4.41.69A6.48,6.48,0,0,1,10,15.7l2.43.49A5.37,5.37,0,0,0,15,16.07l2-.61Z"
    }
  })]) : _c('svg', {
    staticClass: "bi bi-slash-lg",
    attrs: {
      "width": "800px",
      "height": "800px",
      "viewBox": "0 0 16 16",
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "#000000"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.707 1.293a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414-1.414l12-12a1 1 0 0 1 1.414 0z"
    }
  })])]), _vm._v(" "), (_vm.selectedDrawTool === 'free_drawing') ? _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Draw (D)")]) : _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Line (L)")])], 1), _vm._v(" "), (_vm.isToolFreeDrawMenu) ? _c('div', {
    staticClass: "ql-menu-wrapper"
  }, [_c('md-list', {
    staticClass: "ql-menu-container"
  }, [_c('md-list-item', {
    staticClass: "md-icon-button",
    class: {
      'selected': _vm.selectedTool === 'free_drawing'
    },
    on: {
      "click": function($event) {
        return _vm.selectType($event, 'free_drawing')
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "role": "img",
      "aria-label": "Draw"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.18,2,14,.72A2.06,2.06,0,0,0,11,.72L2.91,8.84l-1.32,4A1.16,1.16,0,0,0,1.87,14a1.21,1.21,0,0,0,1.22.29l4-1.32,8.13-8.14A2.06,2.06,0,0,0,15.18,2ZM12.06,6.28,6.37,12,2.74,13.16,4,9.47,9.71,3.76,12.15,6.2ZM14.33,4,13,5.34l-.09-.08L10.56,2.9l1.33-1.33a.89.89,0,0,1,1.2,0l1.24,1.24a.84.84,0,0,1,0,1.2Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M17.32,16.61l-2,.6a6.68,6.68,0,0,1-3.14.17l-2.42-.49a5.2,5.2,0,0,0-3.36.44,5,5,0,0,1-5.75-.86l.8-.9a3.85,3.85,0,0,0,4.41.69A6.48,6.48,0,0,1,10,15.7l2.43.49A5.37,5.37,0,0,0,15,16.07l2-.61Z"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Draw")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-icon-button",
    class: {
      'selected': _vm.selectedTool === 'line'
    },
    on: {
      "click": function($event) {
        return _vm.selectType($event, 'line')
      }
    }
  }, [_c('md-icon', [_c('svg', {
    staticClass: "bi bi-slash-lg",
    attrs: {
      "width": "800px",
      "height": "800px",
      "viewBox": "0 0 16 16",
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "#000000"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.707 1.293a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414-1.414l12-12a1 1 0 0 1 1.414 0z"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Line")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-list-item', {
    class: {
      'selected': _vm.selectedTool === 'highlight'
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.selectType($event, 'highlight')
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "role": "img",
      "aria-label": "Highlight"
    }
  }, [_c('g', {
    attrs: {
      "data-name": "Layer 1-2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.67,10.57,7.9,7.79,2.68,13a.65.65,0,0,0,0,.9L4.55,15.8A.64.64,0,0,0,5,16a.66.66,0,0,0,.46-.19Zm-2-3.52,2.78,2.78L16.7,4.54a.63.63,0,0,0,.19-.48.62.62,0,0,0-.19-.47L14.88,1.76a.66.66,0,0,0-.48-.18.65.65,0,0,0-.47.18ZM7.54,6.66l4.28,4.28-5.61,5.6a1.65,1.65,0,0,1-2.35.06l-.06-.06-.22-.21-.72.72a2,2,0,0,1-.55.37,1.79,1.79,0,0,1-.68.13H.43A.38.38,0,0,1,0,17.28a.4.4,0,0,1,.1-.48l2-2-.18-.18a1.66,1.66,0,0,1,0-2.35l0-.06Zm0,0L13.19,1A1.67,1.67,0,0,1,15.55.91l.06.06,1.87,1.89a1.65,1.65,0,0,1,.06,2.35l-.06.06-5.67,5.67Z"
    }
  })])])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Highlight (H)")])], 1)], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "has-sub-menu",
    class: {
      'selected': _vm.selectedTool === 'stamp'
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-stamp-button additional-options",
    on: {
      "click": function($event) {
        return _vm.openMenuTool('stamp')
      }
    }
  }, [_c('md-icon', [(_vm.stampIndex === 0) ? _c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.66,10.35H10.43c-.07,0-.09,0-.09-.08,0-.25,0-.5,0-.75,0-.06,0-.07-.07-.07H9.83c-.07,0-.08,0-.08-.08V8.55a1.08,1.08,0,0,1,.4-.87A1.76,1.76,0,0,0,10.78,6,1.81,1.81,0,0,0,9.08,4.5H8.9a1.8,1.8,0,0,0-1,3.2,1,1,0,0,1,.37.69c0,.34,0,.67,0,1,0,.06,0,0-.07,0H7.72c-.07,0-.08,0-.08.08,0,.24,0,.49,0,.73,0,.08,0,.09-.1.09H5.32a.36.36,0,0,0-.37.29v1.81a.35.35,0,0,0,.37.3.09.09,0,0,1,.11.08.89.89,0,0,0,.89.67h5.36a.91.91,0,0,0,.89-.67c0-.05,0-.08.1-.08a.36.36,0,0,0,.38-.4V10.74A.36.36,0,0,0,12.66,10.35ZM8.08,7.48A1.45,1.45,0,0,1,7.5,6.3,1.42,1.42,0,0,1,8.28,5a1.48,1.48,0,0,1,2.18,1A1.38,1.38,0,0,1,10,7.39a1.59,1.59,0,0,0-.54.83,2.48,2.48,0,0,0,0,.27c0,.3,0,.59,0,.89,0,0,0,.07-.07.07H8.62c-.06,0-.07,0-.07-.07V8.86a2.66,2.66,0,0,0-.05-.68A1.3,1.3,0,0,0,8.08,7.48ZM8,9.83c0-.06,0-.08.07-.08h2c.06,0,.08,0,.07.08v.46c0,.05,0,.06-.06.06H8s-.07,0-.07-.06Zm3.74,3.36H6.3a.6.6,0,0,1-.55-.35c0-.06,0-.09.06-.09h6.46A.61.61,0,0,1,11.69,13.19Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M16.32,0H1.66A1.67,1.67,0,0,0,0,1.67V16.33A1.67,1.67,0,0,0,1.66,18H16.32A1.68,1.68,0,0,0,18,16.33V1.67A1.68,1.68,0,0,0,16.32,0ZM1.4,1.67a.26.26,0,0,1,.26-.26H16.32a.27.27,0,0,1,.27.26V16.33a.27.27,0,0,1-.27.26H1.66a.26.26,0,0,1-.26-.26Z"
    }
  })]) : (_vm.stampIndex === 1) ? _c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM9,16.59A7.59,7.59,0,1,1,16.59,9,7.61,7.61,0,0,1,9,16.59Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12.66,10.35H10.43c-.07,0-.09,0-.09-.08,0-.25,0-.5,0-.75,0-.06,0-.07-.07-.07H9.83c-.07,0-.08,0-.08-.08V8.55a1.08,1.08,0,0,1,.4-.87A1.76,1.76,0,0,0,10.78,6,1.81,1.81,0,0,0,9.08,4.5H8.9a1.8,1.8,0,0,0-1,3.2,1,1,0,0,1,.37.69c0,.34,0,.67,0,1,0,.06,0,0-.07,0H7.72c-.07,0-.08,0-.08.08,0,.24,0,.49,0,.73,0,.08,0,.09-.1.09H5.32a.36.36,0,0,0-.37.29v1.81a.35.35,0,0,0,.37.3.09.09,0,0,1,.11.08.89.89,0,0,0,.89.67h5.36a.91.91,0,0,0,.89-.67c0-.05,0-.08.1-.08a.36.36,0,0,0,.38-.4V10.74A.36.36,0,0,0,12.66,10.35ZM8.08,7.48A1.45,1.45,0,0,1,7.5,6.3,1.42,1.42,0,0,1,8.28,5a1.48,1.48,0,0,1,2.18,1A1.38,1.38,0,0,1,10,7.39a1.59,1.59,0,0,0-.54.83,2.48,2.48,0,0,0,0,.27c0,.3,0,.59,0,.89,0,0,0,.07-.07.07H8.62c-.06,0-.07,0-.07-.07V8.86a2.66,2.66,0,0,0-.05-.68A1.3,1.3,0,0,0,8.08,7.48ZM8,9.83c0-.06,0-.08.07-.08h2c.06,0,.08,0,.07.08v.46c0,.05,0,.06-.06.06H8s-.07,0-.07-.06Zm3.74,3.36H6.3a.6.6,0,0,1-.55-.35c0-.06,0-.09.06-.09h6.46A.61.61,0,0,1,11.69,13.19Z"
    }
  })]) : (_vm.stampIndex === 2) ? _c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "role": "img",
      "aria-label": "Triangle"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9,0,0,18H18ZM9,3l6.78,13.55H2.22Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.71,12.49H10.06c-.05,0-.06,0-.06-.06v-.56s0,0-.05,0H9.61s-.06,0-.06-.06,0-.4,0-.61a.75.75,0,0,1,.3-.64,1.31,1.31,0,0,0,.46-1.23A1.34,1.34,0,0,0,9.06,8.15H8.93a1.31,1.31,0,0,0-.88.4,1.34,1.34,0,0,0,.1,2,.7.7,0,0,1,.28.51,6.26,6.26,0,0,1,0,.75s0,0,0,0H8.05c-.05,0-.06,0-.06.06s0,.36,0,.54,0,.07-.07.07H6.27A.26.26,0,0,0,6,12.7v1.35a.26.26,0,0,0,.28.22.07.07,0,0,1,.07.06.68.68,0,0,0,.66.5h4a.66.66,0,0,0,.65-.5s0-.06.08-.06A.26.26,0,0,0,12,14v-1.2A.27.27,0,0,0,11.71,12.49ZM8.32,10.37a1.07,1.07,0,0,1-.43-.88,1,1,0,0,1,.58-1,1.09,1.09,0,0,1,1.61.76,1,1,0,0,1-.33,1,1.14,1.14,0,0,0-.4.62,1.5,1.5,0,0,0,0,.2v.66s0,.05-.05.05H8.72s-.06,0-.06-.05,0-.25,0-.39a2.2,2.2,0,0,0,0-.5A.94.94,0,0,0,8.32,10.37Zm-.1,1.73s0,0,.06,0H9.72s0,0,0,0v.34s0,.05,0,.05H8.27s0,0,0-.05ZM11,14.6H7a.45.45,0,0,1-.41-.26c0-.05,0-.07,0-.07h4.79A.44.44,0,0,1,11,14.6Z"
    }
  })]) : _c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "role": "img",
      "aria-label": "Hexagon"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.73,0H5.27L0,5.27v7.46L5.27,18h7.46L18,12.73V5.27ZM5.8,16.73,1.27,12.2V5.8L5.8,1.27h6.4L16.73,5.8v6.4L12.2,16.73Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12.66,10.35H10.43c-.07,0-.09,0-.09-.08,0-.25,0-.5,0-.75,0-.06,0-.07-.07-.07H9.83c-.07,0-.08,0-.08-.08V8.55a1.08,1.08,0,0,1,.4-.87A1.76,1.76,0,0,0,10.78,6,1.81,1.81,0,0,0,9.08,4.5H8.9a1.8,1.8,0,0,0-1,3.2,1,1,0,0,1,.37.69c0,.34,0,.67,0,1,0,.06,0,0-.07,0H7.72c-.07,0-.08,0-.08.08,0,.24,0,.49,0,.73,0,.08,0,.09-.1.09H5.32a.36.36,0,0,0-.37.29v1.81a.35.35,0,0,0,.37.3.09.09,0,0,1,.11.08.89.89,0,0,0,.89.67h5.36a.91.91,0,0,0,.89-.67c0-.05,0-.08.1-.08a.36.36,0,0,0,.38-.4V10.74A.36.36,0,0,0,12.66,10.35ZM8.08,7.48A1.45,1.45,0,0,1,7.5,6.3,1.42,1.42,0,0,1,8.28,5a1.48,1.48,0,0,1,2.18,1A1.38,1.38,0,0,1,10,7.39a1.59,1.59,0,0,0-.54.83,2.48,2.48,0,0,0,0,.27c0,.3,0,.59,0,.89,0,0,0,.07-.07.07H8.62c-.06,0-.07,0-.07-.07V8.86a2.66,2.66,0,0,0-.05-.68A1.3,1.3,0,0,0,8.08,7.48ZM8,9.83c0-.06,0-.08.07-.08h2c.06,0,.08,0,.07.08v.46c0,.05,0,.06-.06.06H8s-.07,0-.07-.06Zm3.74,3.36H6.3a.6.6,0,0,1-.55-.35c0-.06,0-.09.06-.09h6.46A.61.61,0,0,1,11.69,13.19Z"
    }
  })])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Stamp (S)")])], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container",
    on: {
      "click": function($event) {
        return _vm.preventContext($event, 'stamp')
      }
    }
  }, [_c('span', {
    staticClass: "move-button"
  }, [_c('div', {
    staticClass: "fill-button"
  }), _vm._v(" "), _c('md-tooltip', [_vm._v("Change Stamp")])], 1)]), _vm._v(" "), (_vm.isToolMenuStamp) ? _c('div', {
    staticClass: "ql-menu-wrapper"
  }, [_c('md-list', {
    staticClass: "ql-menu-container"
  }, [_c('md-list-item', {
    staticClass: "md-icon-button",
    class: {
      'selected': _vm.stampIndex === 0
    },
    on: {
      "click": function($event) {
        return _vm.selectTool('stamp', 0)
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.66,10.35H10.43c-.07,0-.09,0-.09-.08,0-.25,0-.5,0-.75,0-.06,0-.07-.07-.07H9.83c-.07,0-.08,0-.08-.08V8.55a1.08,1.08,0,0,1,.4-.87A1.76,1.76,0,0,0,10.78,6,1.81,1.81,0,0,0,9.08,4.5H8.9a1.8,1.8,0,0,0-1,3.2,1,1,0,0,1,.37.69c0,.34,0,.67,0,1,0,.06,0,0-.07,0H7.72c-.07,0-.08,0-.08.08,0,.24,0,.49,0,.73,0,.08,0,.09-.1.09H5.32a.36.36,0,0,0-.37.29v1.81a.35.35,0,0,0,.37.3.09.09,0,0,1,.11.08.89.89,0,0,0,.89.67h5.36a.91.91,0,0,0,.89-.67c0-.05,0-.08.1-.08a.36.36,0,0,0,.38-.4V10.74A.36.36,0,0,0,12.66,10.35ZM8.08,7.48A1.45,1.45,0,0,1,7.5,6.3,1.42,1.42,0,0,1,8.28,5a1.48,1.48,0,0,1,2.18,1A1.38,1.38,0,0,1,10,7.39a1.59,1.59,0,0,0-.54.83,2.48,2.48,0,0,0,0,.27c0,.3,0,.59,0,.89,0,0,0,.07-.07.07H8.62c-.06,0-.07,0-.07-.07V8.86a2.66,2.66,0,0,0-.05-.68A1.3,1.3,0,0,0,8.08,7.48ZM8,9.83c0-.06,0-.08.07-.08h2c.06,0,.08,0,.07.08v.46c0,.05,0,.06-.06.06H8s-.07,0-.07-.06Zm3.74,3.36H6.3a.6.6,0,0,1-.55-.35c0-.06,0-.09.06-.09h6.46A.61.61,0,0,1,11.69,13.19Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M16.32,0H1.66A1.67,1.67,0,0,0,0,1.67V16.33A1.67,1.67,0,0,0,1.66,18H16.32A1.68,1.68,0,0,0,18,16.33V1.67A1.68,1.68,0,0,0,16.32,0ZM1.4,1.67a.26.26,0,0,1,.26-.26H16.32a.27.27,0,0,1,.27.26V16.33a.27.27,0,0,1-.27.26H1.66a.26.26,0,0,1-.26-.26Z"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Square")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-icon-button",
    class: {
      'selected': _vm.stampIndex === 1
    },
    on: {
      "click": function($event) {
        return _vm.selectTool('stamp', 1)
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM9,16.59A7.59,7.59,0,1,1,16.59,9,7.61,7.61,0,0,1,9,16.59Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12.66,10.35H10.43c-.07,0-.09,0-.09-.08,0-.25,0-.5,0-.75,0-.06,0-.07-.07-.07H9.83c-.07,0-.08,0-.08-.08V8.55a1.08,1.08,0,0,1,.4-.87A1.76,1.76,0,0,0,10.78,6,1.81,1.81,0,0,0,9.08,4.5H8.9a1.8,1.8,0,0,0-1,3.2,1,1,0,0,1,.37.69c0,.34,0,.67,0,1,0,.06,0,0-.07,0H7.72c-.07,0-.08,0-.08.08,0,.24,0,.49,0,.73,0,.08,0,.09-.1.09H5.32a.36.36,0,0,0-.37.29v1.81a.35.35,0,0,0,.37.3.09.09,0,0,1,.11.08.89.89,0,0,0,.89.67h5.36a.91.91,0,0,0,.89-.67c0-.05,0-.08.1-.08a.36.36,0,0,0,.38-.4V10.74A.36.36,0,0,0,12.66,10.35ZM8.08,7.48A1.45,1.45,0,0,1,7.5,6.3,1.42,1.42,0,0,1,8.28,5a1.48,1.48,0,0,1,2.18,1A1.38,1.38,0,0,1,10,7.39a1.59,1.59,0,0,0-.54.83,2.48,2.48,0,0,0,0,.27c0,.3,0,.59,0,.89,0,0,0,.07-.07.07H8.62c-.06,0-.07,0-.07-.07V8.86a2.66,2.66,0,0,0-.05-.68A1.3,1.3,0,0,0,8.08,7.48ZM8,9.83c0-.06,0-.08.07-.08h2c.06,0,.08,0,.07.08v.46c0,.05,0,.06-.06.06H8s-.07,0-.07-.06Zm3.74,3.36H6.3a.6.6,0,0,1-.55-.35c0-.06,0-.09.06-.09h6.46A.61.61,0,0,1,11.69,13.19Z"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Circle")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-icon-button",
    class: {
      'selected': _vm.stampIndex === 2
    },
    on: {
      "click": function($event) {
        return _vm.selectTool('stamp', 2)
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "role": "img",
      "aria-label": "Triangle"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9,0,0,18H18ZM9,3l6.78,13.55H2.22Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.71,12.49H10.06c-.05,0-.06,0-.06-.06v-.56s0,0-.05,0H9.61s-.06,0-.06-.06,0-.4,0-.61a.75.75,0,0,1,.3-.64,1.31,1.31,0,0,0,.46-1.23A1.34,1.34,0,0,0,9.06,8.15H8.93a1.31,1.31,0,0,0-.88.4,1.34,1.34,0,0,0,.1,2,.7.7,0,0,1,.28.51,6.26,6.26,0,0,1,0,.75s0,0,0,0H8.05c-.05,0-.06,0-.06.06s0,.36,0,.54,0,.07-.07.07H6.27A.26.26,0,0,0,6,12.7v1.35a.26.26,0,0,0,.28.22.07.07,0,0,1,.07.06.68.68,0,0,0,.66.5h4a.66.66,0,0,0,.65-.5s0-.06.08-.06A.26.26,0,0,0,12,14v-1.2A.27.27,0,0,0,11.71,12.49ZM8.32,10.37a1.07,1.07,0,0,1-.43-.88,1,1,0,0,1,.58-1,1.09,1.09,0,0,1,1.61.76,1,1,0,0,1-.33,1,1.14,1.14,0,0,0-.4.62,1.5,1.5,0,0,0,0,.2v.66s0,.05-.05.05H8.72s-.06,0-.06-.05,0-.25,0-.39a2.2,2.2,0,0,0,0-.5A.94.94,0,0,0,8.32,10.37Zm-.1,1.73s0,0,.06,0H9.72s0,0,0,0v.34s0,.05,0,.05H8.27s0,0,0-.05ZM11,14.6H7a.45.45,0,0,1-.41-.26c0-.05,0-.07,0-.07h4.79A.44.44,0,0,1,11,14.6Z"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Triangle")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-icon-button",
    class: {
      'selected': _vm.stampIndex === 3
    },
    on: {
      "click": function($event) {
        return _vm.selectTool('stamp', 3)
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "role": "img",
      "aria-label": "Hexagon"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.73,0H5.27L0,5.27v7.46L5.27,18h7.46L18,12.73V5.27ZM5.8,16.73,1.27,12.2V5.8L5.8,1.27h6.4L16.73,5.8v6.4L12.2,16.73Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12.66,10.35H10.43c-.07,0-.09,0-.09-.08,0-.25,0-.5,0-.75,0-.06,0-.07-.07-.07H9.83c-.07,0-.08,0-.08-.08V8.55a1.08,1.08,0,0,1,.4-.87A1.76,1.76,0,0,0,10.78,6,1.81,1.81,0,0,0,9.08,4.5H8.9a1.8,1.8,0,0,0-1,3.2,1,1,0,0,1,.37.69c0,.34,0,.67,0,1,0,.06,0,0-.07,0H7.72c-.07,0-.08,0-.08.08,0,.24,0,.49,0,.73,0,.08,0,.09-.1.09H5.32a.36.36,0,0,0-.37.29v1.81a.35.35,0,0,0,.37.3.09.09,0,0,1,.11.08.89.89,0,0,0,.89.67h5.36a.91.91,0,0,0,.89-.67c0-.05,0-.08.1-.08a.36.36,0,0,0,.38-.4V10.74A.36.36,0,0,0,12.66,10.35ZM8.08,7.48A1.45,1.45,0,0,1,7.5,6.3,1.42,1.42,0,0,1,8.28,5a1.48,1.48,0,0,1,2.18,1A1.38,1.38,0,0,1,10,7.39a1.59,1.59,0,0,0-.54.83,2.48,2.48,0,0,0,0,.27c0,.3,0,.59,0,.89,0,0,0,.07-.07.07H8.62c-.06,0-.07,0-.07-.07V8.86a2.66,2.66,0,0,0-.05-.68A1.3,1.3,0,0,0,8.08,7.48ZM8,9.83c0-.06,0-.08.07-.08h2c.06,0,.08,0,.07.08v.46c0,.05,0,.06-.06.06H8s-.07,0-.07-.06Zm3.74,3.36H6.3a.6.6,0,0,1-.55-.35c0-.06,0-.09.06-.09h6.46A.61.61,0,0,1,11.69,13.19Z"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Hexagon")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-list-item', {
    class: {
      'selected': _vm.selectedTool === 'image'
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.selectType($event, 'image')
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "role": "img",
      "aria-label": "Image"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.5,0H2.5A2.5,2.5,0,0,0,0,2.5v13A2.5,2.5,0,0,0,2.5,18h13A2.5,2.5,0,0,0,18,15.5V2.5A2.5,2.5,0,0,0,15.5,0Zm1.09,15.74-.84.84H2.25l-.84-.84V2.26l.84-.84h13.5l.84.84Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12,12.5H6a1,1,0,0,1-1-1V10.18a.75.75,0,0,1,.22-.53L7.35,7.51a.75.75,0,0,1,1.06,0h0l2.11,2.1L11.13,9a.76.76,0,0,1,1,0l.6.61a.75.75,0,0,1,.22.53V11.5A1,1,0,0,1,12,12.5Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12.6,5.5H11.4l-.4.4V7.1l.4.4h1.2l.4-.4V5.9Z"
    }
  })])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Image (I)")])], 1)], 1), _vm._v(" "), (_vm.canEditScriptMarkers) ? _c('md-list-item', {
    staticClass: "has-sub-menu",
    class: {
      'selected': _vm.selectedTool === 'scriptMarker'
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-marker-button additional-options",
    attrs: {
      "disabled": _vm.isLocked
    },
    on: {
      "click": function($event) {
        return _vm.openMenuTool('scriptMarker')
      }
    }
  }, [_c('md-icon', [_c('bookmark-type-icon', {
    attrs: {
      "marker-index": _vm.markerIndex
    }
  })], 1), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v(_vm._s(_vm.structureToolTooltip))])], 1), _vm._v(" "), (!_vm.isLocked) ? _c('div', {
    staticClass: "button-container",
    on: {
      "click": function($event) {
        return _vm.preventContext($event, 'scriptMarker')
      }
    }
  }, [_c('span', {
    staticClass: "move-button"
  }, [_c('div', {
    staticClass: "fill-button"
  }), _vm._v(" "), _c('md-tooltip', [_vm._v("Change structure type")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isToolMenuMarker && !_vm.isLocked) ? _c('div', {
    staticClass: "ql-menu-wrapper"
  }, [_c('md-list', {
    staticClass: "ql-menu-container"
  }, [_c('md-list-item', {
    staticClass: "md-icon-button",
    class: {
      'selected': _vm.markerIndex === 0
    },
    on: {
      "click": function($event) {
        return _vm.selectTool('scriptMarker', 0)
      }
    }
  }, [_c('md-icon', [_c('bookmark-type-icon', {
    attrs: {
      "type": "act"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("Act")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-icon-button",
    class: {
      'selected': _vm.markerIndex === 1
    },
    on: {
      "click": function($event) {
        return _vm.selectTool('scriptMarker', 1)
      }
    }
  }, [_c('md-icon', [_c('bookmark-type-icon', {
    attrs: {
      "type": "scene"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("Scene")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-icon-button",
    class: {
      'selected': _vm.markerIndex === 2
    },
    on: {
      "click": function($event) {
        return _vm.selectTool('scriptMarker', 2)
      }
    }
  }, [_c('md-icon', [_c('bookmark-type-icon', {
    attrs: {
      "type": "song"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("Song")])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isIpad) ? _c('md-list-item', {
    staticClass: "only-for-tab",
    class: {
      'selected': _vm.selectedTool === 'copy'
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.selectType($event, 'copy')
      },
      "touchstart": function($event) {
        return _vm.selectType($event, 'copy')
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 89 104.71",
      "role": "img",
      "aria-label": "Copy"
    }
  }, [_c('g', {
    attrs: {
      "data-name": "Layer 2"
    }
  }, [_c('g', {
    attrs: {
      "data-name": "Layer 1"
    }
  }, [_c('path', {
    attrs: {
      "d": "M31.41,83.76A10.5,10.5,0,0,1,20.94,73.29V10.47A10.08,10.08,0,0,1,24,3.08,10.08,10.08,0,0,1,31.41,0H78.53a10.08,10.08,0,0,1,7.39,3.08A10.08,10.08,0,0,1,89,10.47V73.29A10.5,10.5,0,0,1,78.53,83.76Zm0-10.47H78.53V10.47H31.41ZM10.47,104.71a10.08,10.08,0,0,1-7.39-3.08A10.09,10.09,0,0,1,0,94.24V20.94H10.47v73.3H68.06v10.47ZM31.41,73.29v0Z"
    }
  })])])])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Copy")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isIpad) ? _c('md-list-item', {
    staticClass: "only-for-tab",
    class: {
      'selected': _vm.selectedTool === 'paste'
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.selectType($event, 'paste')
      },
      "touchstart": function($event) {
        return _vm.selectType($event, 'paste')
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 89 98.89",
      "role": "img",
      "aria-label": "Paste"
    }
  }, [_c('g', {
    attrs: {
      "data-name": "Layer 2"
    }
  }, [_c('g', {
    attrs: {
      "data-name": "Layer 1"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9.89,98.89A9.53,9.53,0,0,1,2.9,96,9.52,9.52,0,0,1,0,89V19.78a9.56,9.56,0,0,1,2.9-7,9.56,9.56,0,0,1,7-2.9H30.53a13.5,13.5,0,0,1,5.32-7.11,15.14,15.14,0,0,1,17.49,0,13.58,13.58,0,0,1,5.25,7.11H79.11a9.56,9.56,0,0,1,7,2.9,9.56,9.56,0,0,1,2.9,7V89a9.92,9.92,0,0,1-9.89,9.89Zm0-9.89H79.11V19.78H69.22V34.61H19.78V19.78H9.89ZM44.5,19.78a4.85,4.85,0,0,0,4.94-5,4.94,4.94,0,1,0-9.88,0,4.85,4.85,0,0,0,4.94,5Z"
    }
  })])])])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Paste")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-list-item', {
    staticClass: "divider"
  }, [_vm._v(" ")]), _vm._v(" "), _c('md-list-item', {
    class: {
      'selected': _vm.selectedTool === 'undo'
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "disabled": _vm.isLocked
    },
    on: {
      "click": function($event) {
        return _vm.selectType($event, 'undo')
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "role": "img",
      "aria-label": "Undo"
    }
  }, [_c('g', {
    attrs: {
      "data-name": "Layer 1-2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.41,16.06h-8V17.4h8a6.71,6.71,0,0,0,4.66-1.77A5.63,5.63,0,0,0,18,11.29,5.6,5.6,0,0,0,16.08,7,6.65,6.65,0,0,0,11.55,5.2h-9L6.2,1.53,5.26.6,0,5.87l5.26,5.28.94-.93L2.53,6.54H11.4a5.48,5.48,0,0,1,3.65,1.33,4.3,4.3,0,0,1,1.6,3.42,4.31,4.31,0,0,1-1.59,3.43A5.27,5.27,0,0,1,11.41,16.06Z"
    }
  })])])]), _vm._v(" "), (_vm.isMac) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Undo (CMD-Z)")]) : _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Undo (CTRL-Z)")])], 1)], 1), _vm._v(" "), _c('md-list-item', {
    class: {
      'selected': _vm.selectedTool === 'redo'
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "disabled": _vm.isLocked
    },
    on: {
      "click": function($event) {
        return _vm.selectType($event, 'redo')
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "role": "img",
      "aria-label": "Redo"
    }
  }, [_c('g', {
    attrs: {
      "data-name": "Layer 1-2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.59,16.06h8V17.4h-8a6.71,6.71,0,0,1-4.66-1.77A5.63,5.63,0,0,1,0,11.29,5.6,5.6,0,0,1,1.92,7,6.65,6.65,0,0,1,6.45,5.2h9L11.8,1.53,12.74.6,18,5.87l-5.26,5.28-.94-.93,3.67-3.68H6.6A5.48,5.48,0,0,0,3,7.87a4.3,4.3,0,0,0-1.6,3.42,4.31,4.31,0,0,0,1.59,3.43A5.27,5.27,0,0,0,6.59,16.06Z"
    }
  })])])]), _vm._v(" "), (_vm.isMac) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Redo (SHFT-CMD-Z or CMD-Y)")]) : _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Redo (SHFT-CTRL-Z or CTRL-Y)")])], 1)], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "divider"
  }, [_vm._v(" ")]), _vm._v(" "), _c('md-list-item', {
    staticClass: "has-sub-menu"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.openPrintMenu()
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 18 18",
      "role": "img",
      "aria-label": "Print"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16.23,5.21a2.12,2.12,0,0,0-1.51-.63h-1.3V2.12A2.05,2.05,0,0,0,12.79.63,2.08,2.08,0,0,0,11.29,0H6.71a2.08,2.08,0,0,0-1.5.63,2.05,2.05,0,0,0-.63,1.49V4.58H3.28A2.15,2.15,0,0,0,1.14,6.71v5.73a2.15,2.15,0,0,0,.63,1.5,2.11,2.11,0,0,0,1.51.62h1.3v1.32a2.05,2.05,0,0,0,.63,1.49,2.08,2.08,0,0,0,1.5.63h4.58a2.08,2.08,0,0,0,1.5-.63,2.05,2.05,0,0,0,.63-1.49V14.56h1.3a2.11,2.11,0,0,0,1.51-.62,2.15,2.15,0,0,0,.63-1.5V6.71A2.12,2.12,0,0,0,16.23,5.21ZM5.7,1.9l.78-.78h5l.78.78V4.58H5.7Zm6.6,14.2-.78.78h-5L5.7,16.1v-5h6.6Zm2.58-7.49-.55.54H12.82l-.54-.54V7.11l.54-.55h1.51l.55.55Z"
    }
  })])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Print")])], 1), _vm._v(" "), (_vm.isPrintMenu) ? _c('div', {
    staticClass: "ql-menu-wrapper print-paper-menu"
  }, [_c('md-list', {
    staticClass: "ql-menu-container"
  }, [_c('md-list-item', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.printWithMargin(false)
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 1.5C3.72 1.5 3.5 1.72 3.5 2v12c0 .28.22.5.5.5h8c.28 0 .5-.22.5-.5V2c0-.28-.22-.5-.5-.5H4ZM2 2C2 .9 2.9 0 4 0h8c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V2Z",
      "fill": "black"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Cues on page")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.printWithMargin(true)
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 1.5H12c.28 0 .5.22.5.5v12c0 .28-.22.5-.5.5H6V1.5ZM4.5 0H12c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V2c0-1.1.9-2 2-2h.5ZM0 4h1.2v1.4H0V4Zm0 3.3h1.2v1.4H0V7.3Zm0 3.3h1.2V12H0v-1.4Z",
      "fill": "black"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Include cues in margin")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "has-sub-menu"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.openMenuTool('other')
      }
    }
  }, [_c('md-icon', [_c('svg', {
    staticStyle: {
      "width": "28px",
      "height": "28px"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "height": "24px",
      "viewBox": "0 -960 960 960",
      "idth": "24px",
      "fill": "#000000"
    }
  }, [_c('path', {
    attrs: {
      "d": "M184.62-200q-27.62 0-46.12-18.5Q120-237 120-264.62v-430.76q0-27.62 18.5-46.12Q157-760 184.62-760h590.76q27.62 0 46.12 18.5Q840-723 840-695.38v430.76q0 27.62-18.5 46.12Q803-200 775.38-200H184.62ZM500-240h275.38q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93v-430.76q0-9.24-7.69-16.93-7.69-7.69-16.93-7.69H500v480ZM215.38-340h189.24v-40H215.38v40Zm0-120h189.24v-40H215.38v40Zm0-120h189.24v-40H215.38v40Zm340 240h189.24v-40H555.38v40Zm0-120h189.24v-40H555.38v40Zm0-120h189.24v-40H555.38v40Z"
    }
  })])]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("View Settings")])], 1), _vm._v(" "), (_vm.isToolMenu) ? _c('div', {
    staticClass: "ql-menu-wrapper tool-menu"
  }, [_c('md-list', {
    staticClass: "ql-menu-container"
  }, [_c('md-list-item', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.gotopage('first')
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14 3.5H2V5H14V3.5ZM8 8.811L12.939 13.75L14.001 12.689L8.531 7.219C8.238 6.926 7.763 6.926 7.47 7.219L2 12.689L3.061 13.75L8 8.811Z",
      "fill": "black"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Go to First Page")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.gotopage('last')
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 8.189L12.939 3.25L14 4.311L8.531 9.781C8.238 10.074 7.763 10.074 7.47 9.781L2 4.311L3.061 3.25L8 8.189ZM14 13.5V12H2V13.5H14Z",
      "fill": "black"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Go to Last Page")])], 1)], 1), _vm._v(" "), _c('md-list', {
    staticClass: "ql-menu-container"
  }, [_c('md-list-item', {
    staticClass: "md-icon-button",
    class: {
      'selected': _vm.selectedPageType === 'no'
    },
    on: {
      "click": function($event) {
        return _vm.selectPageType('no')
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 1.5C3.72421 1.5 3.5 1.72421 3.5 2V14C3.5 14.2758 3.72421 14.5 4 14.5H12C12.2758 14.5 12.5 14.2758 12.5 14V2C12.5 1.72421 12.2758 1.5 12 1.5H4ZM2 2C2 0.895786 2.89579 0 4 0H12C13.1042 0 14 0.895786 14 2V14C14 15.1042 13.1042 16 12 16H4C2.89579 16 2 15.1042 2 14V2Z",
      "fill": "black"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Single Page")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-icon-button",
    class: {
      'selected': _vm.selectedPageType === 'odd'
    },
    on: {
      "click": function($event) {
        return _vm.selectPageType('odd')
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1.5 4C1.5 3.72421 1.72421 3.5 2 3.5H7.25V13H2C1.72421 13 1.5 12.7758 1.5 12.5V4ZM8.75 13V3.5H14C14.2758 3.5 14.5 3.72421 14.5 4V12.5C14.5 12.7758 14.2758 13 14 13H8.75ZM2 2C0.895786 2 0 2.89579 0 4V12.5C0 13.6042 0.895786 14.5 2 14.5H14C15.1042 14.5 16 13.6042 16 12.5V4C16 2.89579 15.1042 2 14 2H2ZM4.75 5H3V6.5H4V11.5H5.5V5.75C5.5 5.33579 5.16421 5 4.75 5ZM10 6.5H11.5V7.28647L10.4146 7.82918C10.1605 7.95622 10 8.21592 10 8.5V10.75C10 11.1642 10.3358 11.5 10.75 11.5H13V10H11.5V8.96353L12.5854 8.42082C12.8395 8.29378 13 8.03408 13 7.75V5.75C13 5.33579 12.6642 5 12.25 5H10V6.5Z",
      "fill": "black"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Odd Spreads")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-icon-button",
    class: {
      'selected': _vm.selectedPageType === 'even'
    },
    on: {
      "click": function($event) {
        return _vm.selectPageType('even')
      }
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M2 3.5C1.72421 3.5 1.5 3.72421 1.5 4V12.5C1.5 12.7758 1.72421 13 2 13H7.25V3.5H2ZM14 13H8.75V3.5H14C14.2758 3.5 14.5 3.72421 14.5 4V12.5C14.5 12.7758 14.2758 13 14 13ZM0 4C0 2.89579 0.895786 2 2 2H14C15.1042 2 16 2.89579 16 4V12.5C16 13.6042 15.1042 14.5 14 14.5H2C0.895786 14.5 0 13.6042 0 12.5V4ZM10 6.5H11.5V7.5H10V9H11.5V10H10V11.5H12.25C12.6642 11.5 13 11.1642 13 10.75V5.75C13 5.33579 12.6642 5 12.25 5H10V6.5ZM4.5 6.5H3V5H5.25C5.66421 5 6 5.33579 6 5.75V7.75C6 8.03408 5.8395 8.29378 5.58541 8.42082L4.5 8.96353V10H6V11.5H3.75C3.33579 11.5 3 11.1642 3 10.75V8.5C3 8.21592 3.1605 7.95622 3.41459 7.82918L4.5 7.28647V6.5Z",
      "fill": "black"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Even Spreads")])], 1)], 1), _vm._v(" "), (!_vm.listView) ? _c('md-list', {
    staticClass: "ql-menu-container"
  }, [_c('md-list-item', {
    staticClass: "md-icon-button",
    class: {
      'selected': _vm.splitView === 'true'
    },
    on: {
      "click": _vm.toggleSplitView
    }
  }, [_c('md-icon', [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2 2.5A1.5 1.5 0 0 1 3.5 1h9A1.5 1.5 0 0 1 14 2.5v11A1.5 1.5 0 0 1 12.5 15h-9A1.5 1.5 0 0 1 2 13.5v-11ZM7.25 2.5H3.5v11h3.75v-11Zm1.5 0v11h3.75v-11H8.75Z",
      "fill": "black"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v("Split View")])], 1)], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-817a4e8a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/palette/index.vue
// module id = 1271
// module chunks = 21